import 'reflect-metadata';
import ReactDOM from 'react-dom';
import React from 'react';
import './index.scss';
import {
    AlgoRobotDetailPage, AlgoRobotsPage,
    EmailVerificationPage, PhoneNumberVerificationPage, ResetPasswordPage,
    SignInPage, SignUpPage, SignUpResultPage,
} from '@pages';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import {Bootstrap, DI, I18nService, MainLayout, MenuItem, RequireAuth} from 'shared-lib';
import {AuthConst} from "@consts";

const i18nService: I18nService = DI.get(I18nService);

const MenuItems: MenuItem[] = [
    {icon: 'robot', name: 'Algorithmic Robots', to: '/algo-robots'}
];
i18nService.init().then((context: any) => {
    ReactDOM.render(
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    element={
                        <RequireAuth redirectLink={'/sign-in'}>
                            <Bootstrap>
                                <MainLayout menuItems={MenuItems}/>
                            </Bootstrap>
                        </RequireAuth>
                    }
                >
                    <Route path="/" element={<Navigate to="/algo-robots" replace={true}/>}/>
                    <Route path="/algo-robots" element={<AlgoRobotsPage/>}/>
                    <Route path="/algo-robots/:packageId" element={<AlgoRobotDetailPage/>}/>
                </Route>
                <Route path="/sign-in" element={<SignInPage/>}/>
                <Route path="/sign-up" element={<SignUpPage/>}/>
                <Route path={AuthConst.EMAIL_VERIFICATION_PAGE} element={<EmailVerificationPage/>}/>
                <Route path={AuthConst.SIGN_UP_RESULT_PAGE} element={<SignUpResultPage/>}/>
                <Route path={AuthConst.PHONE_NUMBER_VERIFICATION_PAGE}
                       element={<PhoneNumberVerificationPage/>}/>
                <Route path={AuthConst.RESET_PASSWORD_PAGE} element={<ResetPasswordPage/>}/>
            </Routes>
        </BrowserRouter>,
        document.getElementById('root')
    );
})

